import { OndemandVideo } from "@mui/icons-material";
import { FileWordOutlined } from "@ant-design/icons";
import { Row } from "antd";
import PreviewImage from '../GeneralComponents/previewImage';
import Icono from "../IconosDeSitio";

export default function FileList({ document }) {
  const filesListRender = ()=> {
    const type = document.Nombre.substring(document.Nombre.toString().length, document.Nombre.toString().length - 3);
    switch(type) {
        case 'pdf':
            return (
                <>
                    <img style={{ width: "5%", marginRight: "3px" }} src={Icono[22]} alt='' />
                    <div style={{ width: "40%", height: "20px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                        <span>{document.NombreMultimedia}</span>
                    </div>
                    <div>
                    </div>
                </>
            )
        case 'png':
        case 'jpeg':
        case 'jpg':
            return (
                <Row
                style={{ justifyContent: "space-between", cursor: "pointer", alignItems: "center", width: "90%" }}

              >
                
                <PreviewImage
                  urlImage={`https://${document.Multimedia}`} 
                  style={{ width: "30px", height: "30px", marginLeft: '5px' }}
                  imageName={document.name} />
                <div onClick={() => { window.open(document.url, "_blank") }}
                  style={{ fontSize: '17px' ,width: "40%", height: "20px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                  <span>{document.NombreMultimedia}</span>
                </div>
                <div >
                  {!!document.size && `${(document.size / 1000000).toFixed(2)} MB`}
                </div>
              </Row>
            )
        case 'doc':
        case 'docx':
        case 'msword':
        case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
            return (
                <Row style={{ justifyContent: "space-between", cursor: "pointer", alignItems: "center", width: "90%" }} >
                <FileWordOutlined style={{ fontSize: "250%", color: "#148F9F" }} />
                <div style={{ width: "40%", height: "20px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                  <span>{document.NombreMultimedia}</span>
                </div>
                <div>
                  {!!document.size && `${(document.size / 1000000).toFixed(2)} MB`}
                </div>
              </Row>
            )
        default: 
        return (
        <Row
            style={{ justifyContent: "space-between", cursor: "pointer", alignItems: "center", width: "90%" }} >
            <OndemandVideo sx={{ color: "#148F9F", marginLeft: '5px', fontSize: '30px' }} />
            <div style={{ fontSize: '17px', width: "40%", height: "20px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
            <span>{document.NombreMultimedia}</span>
            </div>
            <div>
            {!!document.size && `${(document.size / 1000000).toFixed(2)} MB`}
            </div>
        </Row>
        )
    }
};

  return(
    filesListRender()
  );
}
